module.exports = __webpack_public_path__ + "static/media/Pataspollo.a4a296d5.jpg";